import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	release: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	header: {
		id: 'project-directories.versions.release-version-modal.header',
		defaultMessage: 'Release {name}',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	release: {
		id: 'project-directories.versions.release-version-modal.release',
		defaultMessage: 'Release',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	cancel: {
		id: 'project-directories.versions.release-version-modal.cancel',
		defaultMessage: 'Cancel',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});
export default messages;
